import { render, staticRenderFns } from "./EFTPS.vue?vue&type=template&id=1d5e6e86&"
import script from "./EFTPS.vue?vue&type=script&lang=js&"
export * from "./EFTPS.vue?vue&type=script&lang=js&"
import style0 from "./EFTPS.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports